import classNames from 'classnames';

const DollarBadgeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('dollar-badge-icon', className);

  return (
    <svg className={classes} {...attributes} viewBox="0 0 640 640">
      <path
        d="M320 64C356.8 64 388.8 84.7 404.9 115.1C437.8 105 475 113 501 139C527 165 535 202.3 524.9 235.1C555.3 251.2 576 283.2 576 320C576 356.8 555.3 388.8 524.9 404.9C535 437.8 527 475 501 501C475 527 437.7 535 404.9 524.9C388.8 555.3 356.8 576 320 576C283.2 576 251.2 555.3 235.1 524.9C202.2 535 165 527 139 501C113 475 105 437.7 115.1 404.9C84.7 388.8 64 356.8 64 320C64 283.2 84.7 251.2 115.1 235.1C105 202.2 113 165 139 139C165 113 202.3 105 235.1 115.1C251.2 84.7 283.2 64 320 64zM324 208C313 208 304 217 304 228L304 232C275.2 232.3 252 255.7 252 284.5C252 310.2 270.5 332.1 295.9 336.3L337.6 343.3C343.6 344.3 348 349.5 348 355.6C348 362.5 342.4 368.1 335.5 368.1L280 368C269 368 260 377 260 388C260 399 269 408 280 408L304 408L304 412C304 423 313 432 324 432C335 432 344 423 344 412L344 407.3C369 403.2 388 381.6 388 355.5C388 329.8 369.5 307.9 344.1 303.7L302.4 296.7C296.4 295.7 292 290.5 292 284.4C292 277.5 297.6 271.9 304.5 271.9L352 271.9C363 271.9 372 262.9 372 251.9C372 240.9 363 231.9 352 231.9L344 231.9L344 227.9C344 216.9 335 207.9 324 207.9z"
        fill="#7e57c2"
      />
    </svg>
  );
};

export default DollarBadgeIcon;
